// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N0n4s","content":"styles_content__2Ks29","tableWrap":"styles_tableWrap__2i8IS"};